import * as React from "react"
import { forwardRef, memo } from "react"

const SvgComponent = (props, ref) => (
  <svg
    width={25}
    height={13}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M2.705 12.553 0 1.046l7.439 5.23L12.172 0l4.734 6.276 7.438-5.23-2.704 11.507H2.705Z"
      fill="url(#a)"
    />
    <defs>
      <linearGradient
        id="a"
        x1={11.5}
        y1={-6.5}
        x2={12.172}
        y2={22.36}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.1} stopColor="#FEFEFE" />
        <stop offset={1} stopColor="#EA9393" />
      </linearGradient>
    </defs>
  </svg>
)

const ForwardRef = forwardRef(SvgComponent)
const Memo = memo(ForwardRef)
export default Memo
